// extracted by mini-css-extract-plugin
export default {"multiItemContainer":"multiInputList_multiItemContainer__XArBe"};